export const awsConfig = {
  aws_project_region: 'ap-southeast-2',
  aws_appsync_region: 'ap-southeast-2',
  aws_appsync_graphqlEndpoint:
    'https://to6s4c5pnzgy5brkx37f47sahi.appsync-api.ap-southeast-2.amazonaws.com/graphql',
  aws_appsync_apiKey: 'da2-ua6qmmalwfbpbpiupjkjuip3lm',
  // AUTH
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_region: 'ap-southeast-2',
  aws_user_pools_id: 'ap-southeast-2_O3onHOQcy',
  aws_user_pools_web_client_id: '42g2t67bgg7p0pmclsvn6s10nl',
  // aws_cognito_identity_pool_id:
  //   'ap-southeast-2:c0367f5f-47bf-4528-8644-b7ba790ed83f',
  // 'ap-southeast-2_u87PrV1LW',
  // "aws_cognito_mfa_types": [
  //     "SMS"
  // ],
  oauth: {
    domain: 'conneqt.auth.ap-southeast-2.amazoncognito.com',
    scope: ['openid', 'email', 'phone', 'profile'],
    redirectSignIn: 'https://conneqt.hitiq.com.au/',
    redirectSignOut: 'https://conneqt.hitiq.com.au/',
    responseType: 'code',
  },
  aws_cognito_login_mechanisms: ['PREFERRED_USERNAME'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  // LOGGER
  // aws_logger_access_key_id: 'AKIAXAAKH6TXUWXNNB4L',
  // aws_logger_secret_access_key: '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',
  aws_logger_region: 'ap-southeast-2',
  // EMAIL
  // aws_email_sender_url:
  //   'https://3h5kjs7oiabla33bmuja3lzy3y0jdiaa.lambda-url.ap-southeast-2.on.aws',
  // aws_email_sender_apikey: 'd4bdb886b4f94b7ea11d8e5324a3536a',
  aws_appsync_geoIpEndpoint:
    'https://zwkywb3zq5.execute-api.us-east-2.amazonaws.com/Prod/geoip-lookup',
};
